module.exports = __webpack_public_path__ + "img/m5.5be125da.svg";